import type { API } from "@ca/api";

import { treaty } from "@elysiajs/eden";

// Keep the API import type-only and onResponse inlined: a value import drags the Elysia
// server graph into the browser bundle.
const onResponse = async (response: Response) => {
	if (response.ok && response.headers.get("Content-Type")?.split(";")[0] === "application/json") {
		return response.json();
	}
};

export const client = treaty<API>(window.location.origin, {
	headers: {
		"x-classa-client": "garmin-web",
	},
	onResponse,
});
